import React from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import { Dotdotdot, SelectableList } from 'components';
import { ContentPostDetail } from 'containers';

function ContentSearchResultIdea(props) {
  var clearCurrentSearch = props.clearCurrentSearch,
      handleBackToResults = props.handleBackToResults,
      idea = props.idea,
      orgId = props.orgId;
  var category = idea.PostTemplateTags && idea.PostTemplateTags.length ? idea.PostTemplateTags[0] : null;
  var categorySlug = category ? category.slug : null;
  var categoryName = category ? category.tagName : '';
  var S3Files = idea.PostTemplateS3Files.map(function (t) {
    return t.S3File;
  });
  idea.S3Files = S3Files;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 12px 12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleBackToResults,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon ion-android-arrow-back"
  }), " Back To All Results"), category && /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      clearCurrentSearch(orgId);
      browserHistory.push("/org/".concat(orgId, "/content/category/").concat(categorySlug));
    }
  }, "View All ", categoryName, " Ideas ", /*#__PURE__*/React.createElement("i", {
    className: "icon ion-android-arrow-forward"
  }))), /*#__PURE__*/React.createElement(ContentPostDetail, {
    fullPost: idea
  }));
}

ContentSearchResultIdea.defaultProps = {};
export default ContentSearchResultIdea;